var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"placeholder":"输入userID后 按回车键"},nativeOn:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.addGroupMember.apply(null, arguments)}},model:{value:(_vm.userID),callback:function ($$v) {_vm.userID=$$v},expression:"userID"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }